import { Alert } from "@mui/material";
import { Typography } from "@progress/kendo-react-common";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../app/config";
import { axiosApiInstance } from "../../app/axios";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  createIntegration,
  deleteIntegration,
  getAllFacebookPages,
  getAllIntegrations,
  getIntegrationByID,
  getLeadFormByPageID,
  updateIntegration,
  updatePageSubscription,
} from "./services/integration.services";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridCellProps,
} from "@progress/kendo-react-grid";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import {
  clearIntegrationID,
  clearLeadIntegrationDetails,
  setIntegrationID,
} from "./integrationSlice";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FaceBookLoginButton from "./FaceBookLoginButton";
import IconButton from "../../components/common/IconButton";
import { API_BASE_URL } from "../../_contstants/common";
import { ErrorToast, SuccessToast } from "../../components/toast/Toasts";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}
const PageChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const FBPageList = useAppSelector((state) => state.integration.FBPageList);
  const PageID = formRenderProps.valueGetter("PageID");

  useEffect(() => {
    const fetchLeadForms = async (pageId: string, accessToken: string) => {
      try {
        const payload = {
          pageId: pageId,
          accessToken: accessToken,
        };
        dispatch(getLeadFormByPageID(payload));
      } catch (error) {
        console.error("Error fetching lead forms:", error);
        throw error;
      }
    };

    if (PageID) {
      const filteredPage =
        FBPageList && FBPageList?.filter((page: any) => page?.id === PageID)[0];
      // const pageID = PageID?.split("--")[0];
      // const pageAccessToken = PageID?.split("--")[1];
      fetchLeadForms(PageID, filteredPage?.access_token);
    }
  }, [PageID]);

  return null;
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const FacebookIntegration = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const FBTOKEN = localStorage.getItem("FBTOKEN");

  const FBPageList = useAppSelector((state) => state.integration.FBPageList);
  const loading = useAppSelector((state) => state.integration.loading);
  const LeadFormList = useAppSelector(
    (state) => state.integration.LeadFormList
  );
  const LeadIntegrationList = useAppSelector(
    (state) => state.integration.LeadIntegrationList
  );
  const LeadIntegrationDetails = useAppSelector(
    (state) => state.integration.LeadIntegrationDetails
  );
  const [FBLoading, setFBLoading] = useState<boolean>(false);
  const [formKey, setFormKey] = useState<any>(1);
  const [accesstoken, setAccessToken] = useState<any>();
  const [addIntegration, setAddIntegration] = useState<any>();
  const [lgFBToken, setLgFBToken] = useState(localStorage.getItem("FBTOKEN"));

  useEffect(() => {
    dispatch(getAllIntegrations());
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [LeadIntegrationDetails]);

  useEffect(() => {
    const fetchFacebookPages = async (accessToken: string) => {
      dispatch(getAllFacebookPages(accessToken));
    };
    if (accesstoken) {
      fetchFacebookPages(accesstoken);
    } else {
      setAccessToken(FBTOKEN);
    }
  }, [accesstoken]);

  useEffect(() => {
    const passFBToken = async () => {
      if (accesstoken) {
        // need to call api
        const response = await axiosApiInstance.post(
          `${API_URL}/webhook/WebHookToken`,
          {
            WebHookToken: accesstoken,
          }
        );
        if (response.data.Status === 200 && response.data.Data?.WebHookToken) {
          localStorage.setItem(
            "FBTOKEN",
            response.data.Data?.WebHookToken || ""
          );
          setLgFBToken(response.data.Data?.WebHookToken);
        }
      }
    };
    passFBToken();
  }, [accesstoken]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All"
        ? LeadIntegrationList.length
        : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const createSubscribeLeadCell = (FBPageList: any[]) => (props: any) => {
    return <SubscribeLeadCell {...props} FBPageList={FBPageList} />;
  };

  const SubscribeLeadCell = (props: any) => {
    const { dataItem, FBPageList } = props;

    const handleEditItem = async (data: any) => {
      setFBLoading(true);

      if (FBPageList?.length < 1) {
        setFBLoading(false);
        return null;
      }

      const matchedPage = FBPageList?.filter(
        (page: any) => page?.id === data?.PageID
      );
      if (matchedPage?.length > 0) {
        const pageAccessToken = matchedPage[0].access_token;

        if (data?.IsSubscribe) {
          try {
            const response = await axiosApiInstance.delete(
              `${API_BASE_URL}/${data?.PageID}/subscribed_apps`,
              {
                params: {
                  access_token: pageAccessToken,
                },
              }
            );
            if (response.status === 200) {
              setFBLoading(false);
              SuccessToast(
                `${matchedPage[0].name} leadgen unsubscribe successfully.`
              );
              const res = await dispatch(
                updatePageSubscription({
                  PageID: data?.PageID,
                  IsSubscribe: false,
                })
              );
              if (res.meta.requestStatus === "fulfilled") {
                dispatch(getAllIntegrations());
              }
            } else {
              setFBLoading(false);
            }
          } catch (error: any) {
            setFBLoading(false);
            ErrorToast(
              error?.response?.data?.error?.message || "Something went wrong!!!"
            );
          }
        } else {
          try {
            const response = await axiosApiInstance.post(
              `${API_BASE_URL}/${data?.PageID}/subscribed_apps`,
              {
                access_token: pageAccessToken,
                subscribed_fields: "leadgen",
              }
            );
            if (response.status === 200) {
              setFBLoading(false);
              SuccessToast(
                `${matchedPage[0].name} leadgen subscribe successfully.`
              );
              const res = await dispatch(
                updatePageSubscription({
                  PageID: data?.PageID,
                  IsSubscribe: true,
                })
              );
              if (res.meta.requestStatus === "fulfilled") {
                dispatch(getAllIntegrations());
              }
            } else {
              setFBLoading(false);
            }
          } catch (error: any) {
            setFBLoading(false);
            ErrorToast(
              error?.response?.data?.error?.message || "Something went wrong!!!"
            );
          }
        }
      }
    };

    return (
      <td className="action-td">
        <Button
          type="button"
          themeColor={dataItem?.IsSubscribe ? "error" : "success"}
          fillMode="solid"
          style={{ minWidth: 110, fontWeight: 600 }}
          onClick={() => handleEditItem(dataItem)}
        >
          {dataItem?.IsSubscribe ? "Unsubscribe" : "Subscribe"}
        </Button>
      </td>
    );
  };
  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (ID: number) => {
      dispatch(getIntegrationByID(ID));
      setAddIntegration(true);
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteIntegrationDialog"));
      dispatch(setIntegrationID(ID));
    };

    return (
      <td className="action-td">
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          onClick={() => handleEditItem(props.dataItem?.ID)}
          icon={FiEdit}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          className="color-red"
          onClick={() => handleOpenDeleteDialog(props.dataItem?.ID)}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 1 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleFormClose = (formRenderProps: FormRenderProps) => {
    dispatch(clearLeadIntegrationDetails());
    formRenderProps.onFormReset();
    setAddIntegration(false);
  };

  const handleSubmit = async (values: any) => {
    if (LeadIntegrationDetails?.ID) {
      const updatePayload = {
        ID: values?.ID ? +values?.ID : null,
        Title: values?.Title ? values?.Title : "",
        PageID: values?.PageID ? `${values?.PageID?.split("--")[0]}` : "",
        FormID: values?.FormID ? `${values?.FormID}` : "",
      };
      dispatch(updateIntegration(updatePayload)).then((response: any) => {
        if (response.meta.requestStatus === "fulfilled") {
          dispatch(getAllIntegrations());
          dispatch(clearLeadIntegrationDetails());
        }
      });
    } else {
      const insertPayload = {
        Title: values?.Title ? values?.Title : "",
        PageID: values?.PageID ? `${values?.PageID?.split("--")[0]}` : "",
        FormID: values?.FormID ? `${values?.FormID}` : "",
      };
      dispatch(createIntegration(insertPayload)).then((response: any) => {
        if (response.meta.requestStatus === "fulfilled") {
          const matchedPage = FBPageList?.filter(
            (page: any) => page?.id === values?.PageID?.split("--")[0]
          );
          if (matchedPage?.length > 0) {
            const handleSubscribe = async () => {
              const pageAccessToken = matchedPage[0].access_token;
              const response = await axiosApiInstance.post(
                `${API_BASE_URL}/${
                  values?.PageID?.split("--")[0]
                }/subscribed_apps`,
                {
                  access_token: pageAccessToken,
                  subscribed_fields: "leadgen",
                }
              );
              if (response.status === 200) {
                SuccessToast(
                  `${matchedPage[0].name} leadgen subscribe successfully.`
                );
              }
            };
            handleSubscribe();
          }

          dispatch(getAllIntegrations());
          dispatch(clearLeadIntegrationDetails());
          setFormKey(formKey + 1);
        }
      });
    }
  };

  return (
    <>
      {(loading || FBLoading) && <LoadingPanel gridRef={gridRef} />}
      <DeleteIntegrationDialog />
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={LeadIntegrationDetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <GridLayout cols={[{ width: "100%" }]}>
              <GridLayoutItem>
                {!lgFBToken ? (
                  <GridLayout
                    style={{ marginRight: 20 }}
                    gap={{ cols: 10, rows: 0 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "4px 20px 20px 0",
                      }}
                    >
                      <Typography.h4
                        style={{ marginBottom: 0, marginLeft: "3px" }}
                      >
                        Facebook Integration
                      </Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <FaceBookLoginButton setAccessToken={setAccessToken} />
                    </GridLayoutItem>
                  </GridLayout>
                ) : (
                  <>
                    <GridLayout
                      style={{ marginRight: 20 }}
                      gap={{ cols: 10, rows: 0 }}
                      cols={[
                        { width: "33.33%" },
                        { width: "33.33%" },
                        { width: "33.33%" },
                      ]}
                    >
                      {addIntegration && (
                        <>
                          <GridLayoutItem colSpan={3}>
                            <Typography.h4
                              style={{
                                margin: 0,
                                padding: "4px 20px 20px 0px",
                              }}
                            >
                              {LeadIntegrationDetails?.ID ? "Update " : "Add "}
                              Integration
                            </Typography.h4>
                            <Card
                              style={{
                                padding: 16,
                                marginBottom: 8,
                              }}
                            >
                              <GridLayout
                                style={{
                                  marginRight: 20,
                                }}
                                gap={{
                                  cols: 10,
                                  rows: 10,
                                }}
                                cols={[
                                  {
                                    width: "33.33%",
                                  },
                                  {
                                    width: "33.33%",
                                  },
                                  {
                                    width: "33.33%",
                                  },
                                ]}
                              >
                                {/* <GridLayoutItem colSpan={3}>
                                  
                                </GridLayoutItem> */}
                                <GridLayoutItem>
                                  <Field
                                    wrapperStyle={{
                                      margin: 0,
                                    }}
                                    name="Title"
                                    label="Name"
                                    placeholder="Name"
                                    component={FormTextField}
                                    validator={requiredValidator}
                                  />
                                </GridLayoutItem>
                                <GridLayoutItem>
                                  <Field
                                    wrapperStyle={{
                                      margin: 0,
                                    }}
                                    name="PageID"
                                    placeholder="Facebook Page"
                                    label="Facebook Pages"
                                    component={FormSelectionField}
                                    validator={requiredValidator}
                                    options={FBPageList?.map((pages: any) => {
                                      return {
                                        value: `${pages?.id}`,
                                        label: pages?.name,
                                      };
                                    })}
                                  />
                                </GridLayoutItem>
                                <GridLayoutItem>
                                  <Field
                                    wrapperStyle={{
                                      margin: 0,
                                    }}
                                    name="FormID"
                                    placeholder="Facebook Lead Form"
                                    label="Facebook Lead Forms"
                                    component={FormSelectionField}
                                    validator={requiredValidator}
                                    options={LeadFormList?.map((leads: any) => {
                                      return {
                                        value: leads?.id,
                                        label: leads?.name,
                                      };
                                    })}
                                  />
                                </GridLayoutItem>
                                <GridLayoutItem
                                  colSpan={3}
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  <Button
                                    type={"submit"}
                                    fillMode={"solid"}
                                    themeColor={"primary"}
                                    disabled={!formRenderProps.allowSubmit}
                                  >
                                    {LeadIntegrationDetails?.ID
                                      ? "Update"
                                      : "Create"}
                                  </Button>
                                  <Button
                                    onClick={() =>
                                      handleFormClose(formRenderProps)
                                    }
                                    fillMode={"outline"}
                                    themeColor={"primary"}
                                    style={{
                                      marginLeft: 10,
                                    }}
                                  >
                                    Close
                                  </Button>
                                </GridLayoutItem>
                              </GridLayout>
                            </Card>
                          </GridLayoutItem>
                        </>
                      )}
                      <GridLayoutItem colSpan={3} style={{ marginTop: 10 }}>
                        <div className="d-flex justify-content-between">
                          <Typography.h4
                            style={{
                              margin: 0,
                              padding: "4px 10px 20px 0px",
                            }}
                          >
                            Integration List
                          </Typography.h4>
                          {!addIntegration && (
                            <GridLayoutItem
                              colSpan={3}
                              style={{
                                textAlign: "end",
                                padding: "10px 0px",
                              }}
                            >
                              <Button
                                type="button"
                                themeColor={"primary"}
                                fillMode={"solid"}
                                onClick={() =>
                                  setAddIntegration(!addIntegration)
                                }
                              >
                                Add Integration
                              </Button>
                            </GridLayoutItem>
                          )}
                        </div>
                        <Card
                          style={{
                            padding: 16,
                            marginBottom: 8,
                          }}
                        >
                          <GridLayout
                            style={{
                              marginRight: 20,
                            }}
                            gap={{
                              cols: 10,
                              rows: 10,
                            }}
                            cols={[
                              { width: "33.33%" },
                              { width: "33.33%" },
                              { width: "33.33%" },
                            ]}
                          >
                            <GridLayoutItem colSpan={3}>
                              {LeadIntegrationList &&
                              LeadIntegrationList.length ? (
                                <KendoGrid
                                  style={{
                                    maxHeight: "calc(100vh - 245px)",
                                  }}
                                  filterable={true}
                                  filter={filter}
                                  data={
                                    filter
                                      ? filterBy(
                                          LeadIntegrationList,
                                          filter
                                        ).slice(
                                          page.skip,
                                          page.take + page.skip
                                        )
                                      : LeadIntegrationList.slice(
                                          page.skip,
                                          page.take + page.skip
                                        )
                                  }
                                  onFilterChange={handleFilterChange}
                                  skip={page.skip}
                                  take={page.take}
                                  total={LeadIntegrationList.length}
                                  pageable={{
                                    buttonCount: 5,
                                    pageSizes: [5, 10, 15, "All"],
                                    pageSizeValue: pageSizeValue,
                                    type: "input",
                                  }}
                                  onPageChange={pageChange}
                                  cells={{
                                    headerCell: HeaderCustomCell,
                                    data: MyDataCustomCell,
                                  }}
                                >
                                  <Column field="Title" title="Name" />
                                  <Column
                                    field="ID"
                                    title="Subscription"
                                    cells={{
                                      data: createSubscribeLeadCell(FBPageList),
                                    }}
                                    width={"150px"}
                                    filterable={false}
                                    locked={true}
                                  />
                                  <Column
                                    field="ID"
                                    title="Actions"
                                    cells={{ data: MyEditCommandCell }}
                                    width={"110px"}
                                    filterable={false}
                                    locked={true}
                                  />
                                </KendoGrid>
                              ) : (
                                <Alert severity="error">No Data Found</Alert>
                              )}
                            </GridLayoutItem>
                          </GridLayout>
                        </Card>
                      </GridLayoutItem>
                    </GridLayout>
                  </>
                )}
              </GridLayoutItem>
            </GridLayout>
            <PageChangeWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </>
  );
};

const DeleteIntegrationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const IntegrationID = useAppSelector(
    (state) => state.integration.IntegrationID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteIntegration(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(getAllIntegrations());
        dispatch(closeDialog());
        dispatch(clearIntegrationID());
      } else {
        dispatch(getAllIntegrations());
        dispatch(closeDialog());
        dispatch(clearIntegrationID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteIntegrationDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Integration?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Integration?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor={"error"} />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(IntegrationID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default FacebookIntegration;
